<template>
  <div v-if="monthlyCost" class="cost-estimate">
    <h4>{{ t('createVM.monthlyCostEstimate') }}</h4>
    <div class="cost-details">
      <div class="cost-item">
        <span>{{ t('createVM.computeResource') }}:</span>
        <span>${{ monthlyCost.compute.toFixed(2) }}/{{ t('createVM.month') }}</span>
      </div>
      <div v-if="monthlyCost.gpu > 0" class="cost-item">
        <span>{{ t('createVM.gpuResource', [gpuType, gpuCount]) }}:</span>
        <span>${{ monthlyCost.gpu.toFixed(2) }}/{{ t('createVM.month') }}</span>
      </div>
      <div v-if="monthlyCost.storage > 0" class="cost-item">
        <span>{{ t('createVM.storageResource', { size: diskSizeGb }) }}:</span>
        <span>${{ monthlyCost.storage.toFixed(2) }}/{{ t('createVM.month') }}</span>
      </div>
      <div class="cost-item total">
        <span>{{ t('createVM.total') }}:</span>
        <span>${{ monthlyCost.total.toFixed(2) }}/{{ t('createVM.month') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  name: 'CostEstimateDisplay',
  props: {
    monthlyCost: {
      type: Object,
      required: true
    },
    gpuType: {
      type: String,
      default: ''
    },
    gpuCount: {
      type: Number,
      default: 0
    },
    diskSizeGb: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const { t } = useI18n();

    return {
      t,
      gpuType: props.gpuType,
      gpuCount: props.gpuCount,
      diskSizeGb: props.diskSizeGb
    };
  }
};
</script>

<style scoped>
.cost-estimate {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
}

.cost-estimate h4 {
  margin: 0 0 12px 0;
  color: #495057;
  font-size: 14px;
  font-weight: 600;
}

.cost-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cost-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.cost-item.total {
  border-top: 1px solid #dee2e6;
  padding-top: 8px;
  font-weight: 600;
  color: #28a745;
}
</style>
